module.exports = __webpack_public_path__ + "img/MHH-user.120f50d4.png";